import React, { useState } from "react";
import "./style.scss";
import { findIcon, IconName } from "views/utils/handleIcon";

type SearchToggleProps = {
  isToggle: boolean;
  onToggleOn: () => void;
  onToggleOff: () => void;
};

export const SearchToggle: React.FC<SearchToggleProps> = ({
  isToggle,
  onToggleOn,
  onToggleOff,
}) => {
  const [isOn, setIsOn] = useState<boolean>(isToggle);

  const icon = findIcon(IconName.Arrow);

  const toggle = () => {
    setIsOn(!isOn);
    if (isOn) {
      onToggleOff();
    } else {
      onToggleOn();
    }
  };

  return (
    <>
      <label className="searchToggle">
        <img src={icon} alt="icon" />
        <input type="checkbox" onClick={toggle} />
      </label>
    </>
  );
};
